import _classCallCheck from "D:\\toolabs-projects-2020\\toolabs-studio\\toolabs-studio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\toolabs-projects-2020\\toolabs-studio\\toolabs-studio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

var FlatQueue = /*#__PURE__*/function () {
  function FlatQueue() {
    _classCallCheck(this, FlatQueue);

    this.ids = [];
    this.values = [];
    this.length = 0;
  }

  _createClass(FlatQueue, [{
    key: "clear",
    value: function clear() {
      this.length = 0;
    }
  }, {
    key: "push",
    value: function push(id, value) {
      var pos = this.length++;
      this.ids[pos] = id;
      this.values[pos] = value;

      while (pos > 0) {
        var parent = pos - 1 >> 1;
        var parentValue = this.values[parent];
        if (value >= parentValue) break;
        this.ids[pos] = this.ids[parent];
        this.values[pos] = parentValue;
        pos = parent;
      }

      this.ids[pos] = id;
      this.values[pos] = value;
    }
  }, {
    key: "pop",
    value: function pop() {
      if (this.length === 0) return undefined;
      var top = this.ids[0];
      this.length--;

      if (this.length > 0) {
        var id = this.ids[0] = this.ids[this.length];
        var value = this.values[0] = this.values[this.length];
        var halfLength = this.length >> 1;
        var pos = 0;

        while (pos < halfLength) {
          var left = (pos << 1) + 1;
          var right = left + 1;
          var bestIndex = this.ids[left];
          var bestValue = this.values[left];
          var rightValue = this.values[right];

          if (right < this.length && rightValue < bestValue) {
            left = right;
            bestIndex = this.ids[right];
            bestValue = rightValue;
          }

          if (bestValue >= value) break;
          this.ids[pos] = bestIndex;
          this.values[pos] = bestValue;
          pos = left;
        }

        this.ids[pos] = id;
        this.values[pos] = value;
      }

      return top;
    }
  }, {
    key: "peek",
    value: function peek() {
      if (this.length === 0) return undefined;
      return this.ids[0];
    }
  }, {
    key: "peekValue",
    value: function peekValue() {
      if (this.length === 0) return undefined;
      return this.values[0];
    }
  }]);

  return FlatQueue;
}();

export { FlatQueue as default };